//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from "@angular/core";

//local imports
import { AbstractProgramModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";

@PresenterRegistration(
{
    types: [AbstractProgramModel]
})
@Component({
    selector: 'program-presenter',
    template: '<program-item [id]="data().id" [program]="data()" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgramPresenterComponent {
    public data: WritableSignal<AbstractProgramModel> = signal<AbstractProgramModel>(null);

}